import { render, staticRenderFns } from "./DeliveryParent.vue?vue&type=template&id=07de63ee&"
import script from "./DeliveryParent.vue?vue&type=script&lang=js&"
export * from "./DeliveryParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports